import React from 'react';
import { ScrollReveal } from './useScrollReveal';
export function PainPointsSection() {
  const painPoints = [{
    emoji: '🌋',
    text: 'Tu hijo explota o se bloquea y no sabés qué hacer en ese momento'
  }, {
    emoji: '💥',
    text: 'Querés hablar con él/ella pero cada conversación termina en pelea o silencio'
  }, {
    emoji: '📱',
    text: 'Ves que las redes lo/la afectan pero no tenés cómo abordarlo sin que se ponga defensivo/a'
  }, {
    emoji: '😰',
    text: 'La ansiedad y el estrés escolar están ahí y no tenés un protocolo claro para ayudar'
  }, {
    emoji: '💔',
    text: 'Siente que no encaja, que no vale, que todos están mejor que él/ella — y no sabés qué decir'
  }, {
    emoji: '🏫',
    text: 'Como docente, ves crisis emocionales en el aula y no tenés herramientas concretas para intervenir'
  }, {
    emoji: '🔄',
    text: 'El fin de semana pasa y el lunes todo vuelve a empezar igual'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-187">
      {/* Decorative elements */}
      <div className="absolute -left-40 top-20 w-96 h-96 bg-cosmic-500/5 rounded-full blur-[60px] md:blur-3xl pointer-events-none" data-id="element-188" />
      <div className="absolute -right-40 bottom-20 w-96 h-96 bg-blue-500/5 rounded-full blur-[60px] md:blur-3xl pointer-events-none" data-id="element-189" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-190">
        <ScrollReveal direction="up" className="text-center mb-12" data-id="element-191">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white leading-tight" data-id="element-192">
            ¿Cuántos días más vas a pasar{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cosmic-400 to-blue-400" data-id="element-193">
              sin saber cómo ayudar?
            </span>
          </h2>

          <p className="text-lg md:text-xl text-slate-300 mb-4 leading-relaxed" data-id="element-194">
            Querés acompañar a tu hijo o a tus alumnos. Los amás. Pero nadie te
            enseñó cómo hablar de emociones sin que se cierren, cómo manejar una
            crisis sin explotar vos también, o cómo ayudarlos a tomar decisiones
            sin que sientan que los controlás.
          </p>

          <div className="inline-block bg-cosmic-500/10 border border-cosmic-500/20 text-cosmic-300 font-semibold px-6 py-3 rounded-lg text-lg mt-4" data-id="element-195">
            No es falta de amor. Es falta de herramientas.
          </div>
        </ScrollReveal>

        <div className="bg-navy-800 border border-navy-700 rounded-2xl p-6 md:p-10 shadow-xl relative overflow-hidden" data-id="element-196">
          <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-r from-blue-500 via-cosmic-500 to-purple-500" data-id="element-197" />
          <ul className="space-y-6" data-id="element-198">
            {painPoints.map((point, index) => <ScrollReveal as="li" key={index} direction="left" delay={index + 1} className="flex items-start gap-4" data-id="element-199">
                <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-200">
                  {point.emoji}
                </span>
                <span className="text-slate-200 text-lg" data-id="element-201">{point.text}</span>
              </ScrollReveal>)}
          </ul>
        </div>

        <ScrollReveal direction="up" className="text-center mt-16" data-id="element-202">
          <h3 className="text-2xl md:text-3xl font-bold text-gradient-cosmic" data-id="element-203">
            ¿Y si hoy fuera el último día que pasás sin saber cómo ayudar?
          </h3>
        </ScrollReveal>
      </div>
    </section>;
}